
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49 13c-.6-2.1-2.3-3.8-4.4-4.4C40.7 7.5 25 7.5 25 7.5s-15.7 0-19.6 1C3.3 9.1 1.6 10.8 1 13c-1 3.9-1 12-1 12s0 8.2 1 12c.6 2.1 2.3 3.8 4.4 4.4 4 1.1 19.6 1.1 19.6 1.1s15.7 0 19.6-1c2.1-.6 3.8-2.3 4.4-4.4 1-3.9 1-12 1-12s0-8.2-1-12.1zM20 32.5v-15L33 25l-13 7.5z","fill":"#fff"}})])
          )
        }
      }
    